module.exports = __webpack_public_path__ + "assets/img/24.878abc03.jpg";